<template>
  <div class="container cnt-btns">
    <b-button
      squared
      :class="!this.routerPath ? 'one' : 'two'"
      :to="{ name: 'leyesTramite' }"
      >Proyectos de Ley en Trámite en el Congreso Nacional 2018-2022</b-button
    >
    <b-button
      squared
      :class="`${this.routerPath ? 'one' : 'two'} center`"
      :to="{ name: 'leyesPromulgadas' }"
    >
      <span> Leyes Promulgadas durante {{ anio }} </span>
    </b-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      anio: process.env.VUE_APP_ANIO,
    };
  },
  computed: {
    routerPath: function() {
      const { path } = this.$route;

      return path.includes("/promulgadas");
    },
  },
};
</script>

<style scoped>
.one {
  background: #052333 !important;
  color: white !important;
  border: none;
  font-weight: 700 !important;
  max-width: 160px;
  min-height: 70px;
  font-size: 13px;
}

.cnt-btns {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
}

.two {
  color: #052333;
  background: #efefef;
  border: none;
  max-width: 160px;
  min-height: 70px;
  font-size: 13px;
}
a.center {
  display: flex;
  align-items: center;
}

.two:hover {
  background: #24c6ab;
  color: #052333;
}

@media screen and (max-width: 767px) {
  .btn-btn {
    margin-left: 90px;
  }
}

@media screen and (max-width: 491px) {
  .btn-btn {
    margin-left: 30px;
  }
}
</style>
